import Aos from "aos";
import { useEffect } from "react";

const BankvoleExpertiseSection = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-expertise">
      <div className="bv-expertise-inner" data-aos="fade-up" data-aos-duration="1000">
        <div className="bv-expertise-left" data-aos="fade-right" data-aos-delay="200">
          <span className="bv-eyebrow bv-eyebrow--dark">
            POWERED BY CHECKOFF FINANCE
          </span>
          <h2 className="bv-expertise-title">
            Financial expertise meets modern technology.
          </h2>
          <p className="bv-expertise-text">
            Built on the trusted foundation of Checkoff Finance, Bankvole
            delivers a secure, reliable and rewarding financial planning
            experience.
          </p>
        </div>
        <div className="bv-expertise-right" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000" data-aos-easing="ease-out-cubic">
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/bankvole-expert.png`}
            alt="Checkoff Finance representative"
            className="bv-expertise-img"
          />
        </div>
      </div>
    </section>
  );
};

export default BankvoleExpertiseSection;